import type { PlcManufacturerFaultLibrary } from "./types";

export const phoenix_contactFaultLibrary: PlcManufacturerFaultLibrary = {
  manufacturer_id: "phoenix-contact",
  manufacturer_name: "Phoenix Contact",
  faults: [
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-no-power",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "AXC F 1152 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "power", "no power", "cpu"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-stop-mode",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "AXC F 1152 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-unexpected-stop",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "AXC F 1152 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-watchdog",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Watchdog مال AXC F 1152 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "watchdog", "scan time", "cycle"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-scan-time",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Scan Time مال AXC F 1152 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "scan", "performance", "cycle time"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-cpu-overtemp",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "حرارة AXC F 1152 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "temperature", "overheat", "cpu"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-battery",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Battery/Backup مال AXC F 1152 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "battery", "backup", "retain"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-memory",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Memory Error في AXC F 1152",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "memory", "card", "storage"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-retain",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "بيانات Retain مال AXC F 1152 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "retain", "memory", "restart"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-rtc",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "ساعة RTC مال AXC F 1152 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-firmware",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Firmware مال AXC F 1152 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "firmware", "revision", "compatibility"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-project-mismatch",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Project داخل AXC F 1152 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "project mismatch", "online offline", "compare"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-download-fail",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Download إلى AXC F 1152 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "download", "transfer", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-upload-fail",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Upload من AXC F 1152 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "upload", "access", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-password",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ AXC F 1152",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "password", "protection", "access"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-programming-connection",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ AXC F 1152",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "online", "connection", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-ip-conflict",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ AXC F 1152",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-network-link",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Ethernet Link مال AXC F 1152 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "ethernet", "link", "network"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-industrial-protocol",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا AXC F 1152 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-serial-comm",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا AXC F 1152 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-remote-io",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Remote I/O مرتبط بـ AXC F 1152 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "remote io", "distributed io", "offline"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-module-missing",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Module مفقود من تكوين AXC F 1152",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "module missing", "hardware configuration"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-module-mismatch",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Module type/revision mismatch ويا AXC F 1152",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "module mismatch", "revision"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-backplane",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Backplane/Bus Fault مال AXC F 1152",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "backplane", "bus fault", "rack"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-digital-input",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Digital Input ما يقرا على AXC F 1152",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "digital input", "di", "sensor"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-digital-output",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "digital output", "do", "relay"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-input-stuck",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Input على AXC F 1152 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "input stuck", "di"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-output-stuck",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Output على AXC F 1152 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "output stuck", "welded", "force"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-analog-input-zero",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Analog Input على AXC F 1152 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-analog-input-max",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Analog Input على AXC F 1152 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "analog overrange", "ai"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-analog-noise",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Analog Reading على AXC F 1152 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "analog noise", "shield", "filter"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-analog-output",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Analog Output من AXC F 1152 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "analog output", "ao", "4-20ma"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-hsc",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "High Speed Counter على AXC F 1152 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-encoder",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Encoder ويا AXC F 1152 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "encoder", "position", "a b z"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-force",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Force/Override فعال على AXC F 1152",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "force", "override", "test mode"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-interlock",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من AXC F 1152",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "interlock", "permissive", "logic"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-safety",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ AXC F 1152 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-motion",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Motion/Axis command من AXC F 1152 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-pid",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "PID داخل AXC F 1152 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "pid", "tuning", "control loop"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-startup",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "AXC F 1152 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "startup", "power cycle", "restart"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-random-reset",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "AXC F 1152 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "reset", "reboot", "power dip"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-data-corruption",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "بيانات داخل AXC F 1152 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1152-axc-f-1152-diag-log",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1152",
      model: "AXC F 1152",
      code: null,
      title_ar: "Diagnostic/Event log مال AXC F 1152 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1152",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1152", "AXC F 1152", "diagnostic log", "event log", "history"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-no-power",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "AXC F 1252 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "power", "no power", "cpu"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-stop-mode",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "AXC F 1252 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-unexpected-stop",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "AXC F 1252 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-watchdog",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Watchdog مال AXC F 1252 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "watchdog", "scan time", "cycle"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-scan-time",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Scan Time مال AXC F 1252 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "scan", "performance", "cycle time"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-cpu-overtemp",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "حرارة AXC F 1252 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "temperature", "overheat", "cpu"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-battery",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Battery/Backup مال AXC F 1252 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "battery", "backup", "retain"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-memory",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Memory Error في AXC F 1252",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "memory", "card", "storage"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-retain",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "بيانات Retain مال AXC F 1252 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "retain", "memory", "restart"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-rtc",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "ساعة RTC مال AXC F 1252 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-firmware",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Firmware مال AXC F 1252 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "firmware", "revision", "compatibility"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-project-mismatch",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Project داخل AXC F 1252 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "project mismatch", "online offline", "compare"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-download-fail",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Download إلى AXC F 1252 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "download", "transfer", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-upload-fail",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Upload من AXC F 1252 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "upload", "access", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-password",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ AXC F 1252",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "password", "protection", "access"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-programming-connection",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ AXC F 1252",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "online", "connection", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-ip-conflict",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ AXC F 1252",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-network-link",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Ethernet Link مال AXC F 1252 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "ethernet", "link", "network"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-industrial-protocol",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا AXC F 1252 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-serial-comm",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا AXC F 1252 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-remote-io",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Remote I/O مرتبط بـ AXC F 1252 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "remote io", "distributed io", "offline"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-module-missing",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Module مفقود من تكوين AXC F 1252",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "module missing", "hardware configuration"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-module-mismatch",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Module type/revision mismatch ويا AXC F 1252",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "module mismatch", "revision"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-backplane",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Backplane/Bus Fault مال AXC F 1252",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "backplane", "bus fault", "rack"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-digital-input",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Digital Input ما يقرا على AXC F 1252",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "digital input", "di", "sensor"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-digital-output",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "digital output", "do", "relay"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-input-stuck",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Input على AXC F 1252 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "input stuck", "di"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-output-stuck",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Output على AXC F 1252 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "output stuck", "welded", "force"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-analog-input-zero",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Analog Input على AXC F 1252 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-analog-input-max",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Analog Input على AXC F 1252 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "analog overrange", "ai"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-analog-noise",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Analog Reading على AXC F 1252 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "analog noise", "shield", "filter"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-analog-output",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Analog Output من AXC F 1252 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "analog output", "ao", "4-20ma"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-hsc",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "High Speed Counter على AXC F 1252 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-encoder",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Encoder ويا AXC F 1252 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "encoder", "position", "a b z"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-force",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Force/Override فعال على AXC F 1252",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "force", "override", "test mode"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-interlock",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من AXC F 1252",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "interlock", "permissive", "logic"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-safety",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ AXC F 1252 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-motion",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Motion/Axis command من AXC F 1252 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-pid",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "PID داخل AXC F 1252 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "pid", "tuning", "control loop"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-startup",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "AXC F 1252 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "startup", "power cycle", "restart"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-random-reset",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "AXC F 1252 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "reset", "reboot", "power dip"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-data-corruption",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "بيانات داخل AXC F 1252 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-1252-axc-f-1252-diag-log",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-1252",
      model: "AXC F 1252",
      code: null,
      title_ar: "Diagnostic/Event log مال AXC F 1252 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 1252",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 1252", "AXC F 1252", "diagnostic log", "event log", "history"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-no-power",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "AXC F 2152 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "power", "no power", "cpu"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-stop-mode",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "AXC F 2152 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-unexpected-stop",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "AXC F 2152 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-watchdog",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Watchdog مال AXC F 2152 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "watchdog", "scan time", "cycle"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-scan-time",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Scan Time مال AXC F 2152 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "scan", "performance", "cycle time"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-cpu-overtemp",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "حرارة AXC F 2152 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "temperature", "overheat", "cpu"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-battery",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Battery/Backup مال AXC F 2152 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "battery", "backup", "retain"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-memory",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Memory Error في AXC F 2152",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "memory", "card", "storage"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-retain",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "بيانات Retain مال AXC F 2152 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "retain", "memory", "restart"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-rtc",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "ساعة RTC مال AXC F 2152 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-firmware",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Firmware مال AXC F 2152 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "firmware", "revision", "compatibility"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-project-mismatch",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Project داخل AXC F 2152 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "project mismatch", "online offline", "compare"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-download-fail",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Download إلى AXC F 2152 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "download", "transfer", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-upload-fail",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Upload من AXC F 2152 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "upload", "access", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-password",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ AXC F 2152",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "password", "protection", "access"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-programming-connection",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ AXC F 2152",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "online", "connection", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-ip-conflict",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ AXC F 2152",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-network-link",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Ethernet Link مال AXC F 2152 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "ethernet", "link", "network"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-industrial-protocol",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا AXC F 2152 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-serial-comm",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا AXC F 2152 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-remote-io",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Remote I/O مرتبط بـ AXC F 2152 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "remote io", "distributed io", "offline"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-module-missing",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Module مفقود من تكوين AXC F 2152",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "module missing", "hardware configuration"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-module-mismatch",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Module type/revision mismatch ويا AXC F 2152",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "module mismatch", "revision"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-backplane",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Backplane/Bus Fault مال AXC F 2152",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "backplane", "bus fault", "rack"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-digital-input",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Digital Input ما يقرا على AXC F 2152",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "digital input", "di", "sensor"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-digital-output",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "digital output", "do", "relay"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-input-stuck",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Input على AXC F 2152 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "input stuck", "di"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-output-stuck",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Output على AXC F 2152 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "output stuck", "welded", "force"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-analog-input-zero",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Analog Input على AXC F 2152 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-analog-input-max",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Analog Input على AXC F 2152 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "analog overrange", "ai"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-analog-noise",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Analog Reading على AXC F 2152 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "analog noise", "shield", "filter"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-analog-output",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Analog Output من AXC F 2152 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "analog output", "ao", "4-20ma"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-hsc",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "High Speed Counter على AXC F 2152 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-encoder",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Encoder ويا AXC F 2152 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "encoder", "position", "a b z"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-force",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Force/Override فعال على AXC F 2152",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "force", "override", "test mode"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-interlock",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من AXC F 2152",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "interlock", "permissive", "logic"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-safety",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ AXC F 2152 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-motion",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Motion/Axis command من AXC F 2152 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-pid",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "PID داخل AXC F 2152 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "pid", "tuning", "control loop"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-startup",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "AXC F 2152 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "startup", "power cycle", "restart"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-random-reset",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "AXC F 2152 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "reset", "reboot", "power dip"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-data-corruption",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "بيانات داخل AXC F 2152 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-2152-axc-f-2152-diag-log",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: "AXC F 2152",
      code: null,
      title_ar: "Diagnostic/Event log مال AXC F 2152 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 2152",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 2152", "AXC F 2152", "diagnostic log", "event log", "history"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-no-power",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "AXC F 3152 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "power", "no power", "cpu"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-stop-mode",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "AXC F 3152 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-unexpected-stop",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "AXC F 3152 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-watchdog",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Watchdog مال AXC F 3152 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "watchdog", "scan time", "cycle"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-scan-time",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Scan Time مال AXC F 3152 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "scan", "performance", "cycle time"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-cpu-overtemp",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "حرارة AXC F 3152 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "temperature", "overheat", "cpu"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-battery",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Battery/Backup مال AXC F 3152 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "battery", "backup", "retain"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-memory",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Memory Error في AXC F 3152",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "memory", "card", "storage"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-retain",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "بيانات Retain مال AXC F 3152 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "retain", "memory", "restart"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-rtc",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "ساعة RTC مال AXC F 3152 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-firmware",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Firmware مال AXC F 3152 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "firmware", "revision", "compatibility"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-project-mismatch",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Project داخل AXC F 3152 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "project mismatch", "online offline", "compare"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-download-fail",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Download إلى AXC F 3152 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "download", "transfer", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-upload-fail",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Upload من AXC F 3152 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "upload", "access", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-password",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ AXC F 3152",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "password", "protection", "access"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-programming-connection",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ AXC F 3152",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "online", "connection", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-ip-conflict",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ AXC F 3152",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-network-link",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Ethernet Link مال AXC F 3152 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "ethernet", "link", "network"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-industrial-protocol",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا AXC F 3152 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-serial-comm",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا AXC F 3152 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-remote-io",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Remote I/O مرتبط بـ AXC F 3152 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "remote io", "distributed io", "offline"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-module-missing",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Module مفقود من تكوين AXC F 3152",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "module missing", "hardware configuration"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-module-mismatch",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Module type/revision mismatch ويا AXC F 3152",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "module mismatch", "revision"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-backplane",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Backplane/Bus Fault مال AXC F 3152",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "backplane", "bus fault", "rack"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-digital-input",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Digital Input ما يقرا على AXC F 3152",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "digital input", "di", "sensor"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-digital-output",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "digital output", "do", "relay"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-input-stuck",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Input على AXC F 3152 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "input stuck", "di"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-output-stuck",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Output على AXC F 3152 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "output stuck", "welded", "force"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-analog-input-zero",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Analog Input على AXC F 3152 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-analog-input-max",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Analog Input على AXC F 3152 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "analog overrange", "ai"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-analog-noise",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Analog Reading على AXC F 3152 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "analog noise", "shield", "filter"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-analog-output",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Analog Output من AXC F 3152 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "analog output", "ao", "4-20ma"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-hsc",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "High Speed Counter على AXC F 3152 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-encoder",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Encoder ويا AXC F 3152 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "encoder", "position", "a b z"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-force",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Force/Override فعال على AXC F 3152",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "force", "override", "test mode"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-interlock",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من AXC F 3152",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "interlock", "permissive", "logic"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-safety",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ AXC F 3152 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-motion",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Motion/Axis command من AXC F 3152 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-pid",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "PID داخل AXC F 3152 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "pid", "tuning", "control loop"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-startup",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "AXC F 3152 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "startup", "power cycle", "restart"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-random-reset",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "AXC F 3152 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "reset", "reboot", "power dip"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-data-corruption",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "بيانات داخل AXC F 3152 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "phoenix-contact-plcnext-axc-f-3152-axc-f-3152-diag-log",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-3152",
      model: "AXC F 3152",
      code: null,
      title_ar: "Diagnostic/Event log مال AXC F 3152 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AXC F 3152",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext AXC F 3152", "AXC F 3152", "diagnostic log", "event log", "history"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-no-power",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "RFC 4072R ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "power", "no power", "cpu"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-stop-mode",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "RFC 4072R يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-unexpected-stop",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "RFC 4072R يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-watchdog",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Watchdog مال RFC 4072R يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "watchdog", "scan time", "cycle"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-scan-time",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Scan Time مال RFC 4072R عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "scan", "performance", "cycle time"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-cpu-overtemp",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "حرارة RFC 4072R ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "temperature", "overheat", "cpu"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-battery",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Battery/Backup مال RFC 4072R ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "battery", "backup", "retain"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-memory",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Memory Error في RFC 4072R",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "memory", "card", "storage"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-retain",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "بيانات Retain مال RFC 4072R تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "retain", "memory", "restart"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-rtc",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "ساعة RTC مال RFC 4072R غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-firmware",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Firmware مال RFC 4072R مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "firmware", "revision", "compatibility"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-project-mismatch",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Project داخل RFC 4072R مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "project mismatch", "online offline", "compare"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-download-fail",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Download إلى RFC 4072R يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "download", "transfer", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-upload-fail",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Upload من RFC 4072R يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "upload", "access", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-password",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ RFC 4072R",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "password", "protection", "access"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-programming-connection",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ RFC 4072R",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "online", "connection", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-ip-conflict",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ RFC 4072R",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-network-link",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Ethernet Link مال RFC 4072R ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "ethernet", "link", "network"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-industrial-protocol",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا RFC 4072R يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-serial-comm",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا RFC 4072R ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-remote-io",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Remote I/O مرتبط بـ RFC 4072R Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "remote io", "distributed io", "offline"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-module-missing",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Module مفقود من تكوين RFC 4072R",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "module missing", "hardware configuration"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-module-mismatch",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Module type/revision mismatch ويا RFC 4072R",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "module mismatch", "revision"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-backplane",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Backplane/Bus Fault مال RFC 4072R",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "backplane", "bus fault", "rack"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-digital-input",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Digital Input ما يقرا على RFC 4072R",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "digital input", "di", "sensor"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-digital-output",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "digital output", "do", "relay"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-input-stuck",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Input على RFC 4072R يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "input stuck", "di"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-output-stuck",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Output على RFC 4072R يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "output stuck", "welded", "force"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-analog-input-zero",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Analog Input على RFC 4072R يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-analog-input-max",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Analog Input على RFC 4072R يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "analog overrange", "ai"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-analog-noise",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Analog Reading على RFC 4072R تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "analog noise", "shield", "filter"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-analog-output",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Analog Output من RFC 4072R مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "analog output", "ao", "4-20ma"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-hsc",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "High Speed Counter على RFC 4072R ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-encoder",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Encoder ويا RFC 4072R يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "encoder", "position", "a b z"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-force",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Force/Override فعال على RFC 4072R",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "force", "override", "test mode"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-interlock",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من RFC 4072R",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "interlock", "permissive", "logic"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-safety",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ RFC 4072R يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-motion",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Motion/Axis command من RFC 4072R يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-pid",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "PID داخل RFC 4072R غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "pid", "tuning", "control loop"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-startup",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "RFC 4072R ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "startup", "power cycle", "restart"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-random-reset",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "RFC 4072R يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "reset", "reboot", "power dip"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-data-corruption",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "بيانات داخل RFC 4072R تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072r-diag-log",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072R",
      code: null,
      title_ar: "Diagnostic/Event log مال RFC 4072R مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072R",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072R", "diagnostic log", "event log", "history"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-no-power",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "RFC 4072S ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "power", "no power", "cpu"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-stop-mode",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "RFC 4072S يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-unexpected-stop",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "RFC 4072S يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-watchdog",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Watchdog مال RFC 4072S يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "watchdog", "scan time", "cycle"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-scan-time",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Scan Time مال RFC 4072S عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "scan", "performance", "cycle time"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-cpu-overtemp",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "حرارة RFC 4072S ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "temperature", "overheat", "cpu"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-battery",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Battery/Backup مال RFC 4072S ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "battery", "backup", "retain"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-memory",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Memory Error في RFC 4072S",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "memory", "card", "storage"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-retain",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "بيانات Retain مال RFC 4072S تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "retain", "memory", "restart"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-rtc",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "ساعة RTC مال RFC 4072S غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-firmware",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Firmware مال RFC 4072S مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "firmware", "revision", "compatibility"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-project-mismatch",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Project داخل RFC 4072S مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "project mismatch", "online offline", "compare"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-download-fail",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Download إلى RFC 4072S يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "download", "transfer", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-upload-fail",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Upload من RFC 4072S يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "upload", "access", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-password",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ RFC 4072S",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "password", "protection", "access"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-programming-connection",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ RFC 4072S",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: PLCnext Engineer.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "online", "connection", "programming"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-ip-conflict",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ RFC 4072S",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-network-link",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Ethernet Link مال RFC 4072S ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "ethernet", "link", "network"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-industrial-protocol",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا RFC 4072S يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-serial-comm",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا RFC 4072S ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-remote-io",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Remote I/O مرتبط بـ RFC 4072S Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "remote io", "distributed io", "offline"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-module-missing",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Module مفقود من تكوين RFC 4072S",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "module missing", "hardware configuration"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-module-mismatch",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Module type/revision mismatch ويا RFC 4072S",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "module mismatch", "revision"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-backplane",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Backplane/Bus Fault مال RFC 4072S",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "backplane", "bus fault", "rack"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-digital-input",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Digital Input ما يقرا على RFC 4072S",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "digital input", "di", "sensor"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-digital-output",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "digital output", "do", "relay"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-input-stuck",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Input على RFC 4072S يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "input stuck", "di"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-output-stuck",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Output على RFC 4072S يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "output stuck", "welded", "force"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-analog-input-zero",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Analog Input على RFC 4072S يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-analog-input-max",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Analog Input على RFC 4072S يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "analog overrange", "ai"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-analog-noise",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Analog Reading على RFC 4072S تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "analog noise", "shield", "filter"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-analog-output",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Analog Output من RFC 4072S مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "analog output", "ao", "4-20ma"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-hsc",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "High Speed Counter على RFC 4072S ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-encoder",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Encoder ويا RFC 4072S يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "encoder", "position", "a b z"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-force",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Force/Override فعال على RFC 4072S",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "force", "override", "test mode"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-interlock",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من RFC 4072S",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "interlock", "permissive", "logic"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-safety",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ RFC 4072S يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-motion",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Motion/Axis command من RFC 4072S يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-pid",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "PID داخل RFC 4072S غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "pid", "tuning", "control loop"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-startup",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "RFC 4072S ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "startup", "power cycle", "restart"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-random-reset",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "RFC 4072S يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "reset", "reboot", "power dip"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-data-corruption",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "بيانات داخل RFC 4072S تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "phoenix-contact-plcnext-rfc-4072-rfc-4072s-diag-log",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-rfc-4072",
      model: "RFC 4072S",
      code: null,
      title_ar: "Diagnostic/Event log مال RFC 4072S مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "RFC 4072S",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Phoenix Contact", "PLCnext RFC 4072", "RFC 4072S", "diagnostic log", "event log", "history"],
    },
  ],
};
